import { z } from 'zod';
import {
    DEFAULT_FINANCE_CURRENCY,
    FINANCE_CURRENCY_CODES,
} from './asset-finance-constants.js';

export const FinanceCurrencyEnum = z.enum(['TRY', 'USD', 'EUR', 'GBP']);

/**
 * @param {unknown} value
 * @returns {'TRY'|'USD'|'EUR'|'GBP'}
 */
export function normalizeFinanceCurrency(value) {
    const code = String(value || '').trim().toUpperCase();
    return FINANCE_CURRENCY_CODES.includes(code) ? code : DEFAULT_FINANCE_CURRENCY;
}

export const optionalFinanceCurrencySchema = z.preprocess((value) => {
    if (value === '' || value == null) return undefined;
    return String(value).trim().toUpperCase();
}, FinanceCurrencyEnum.optional());

export const financeCurrencyWithDefaultSchema = optionalFinanceCurrencySchema.transform(
    (value) => value || DEFAULT_FINANCE_CURRENCY,
);
